import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge";
import useWidgetBadges from "@insite/client-framework/Common/Hooks/useWidgetBadges";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
// import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
// import ProductAddToListLink, {
// ProductAddToListLinkStyles,
// } from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductImageBadges from "@insite/content-library/Components/ProductImageBadges";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductTextBadges from "@insite/content-library/Components/ProductTextBadges";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Badge from "@insite/mobius/Badge";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, injectCss } from "@insite/mobius/utilities";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import UCSColors from "@ucs/Utils/UCSColors";
import React, { lazy, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {
    updateProductInfo,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    extendedStyles?: ProductCarouselProductFullStyles;
    actionsTemplate?: (product: ProductModel) => React.ReactNode;
    showImageBadges?: boolean;
    maximumNumberOfImageBadges?: number;
    showTextBadges?: boolean;
    maximumNumberOfTextBadges?: number;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps> & HasHistory;

export interface ProductCarouselProductFullStyles {
    container?: GridContainerProps;
    innerContainer?: GridContainerProps;
    imageGridItem?: GridItemProps;
    contentGridItem?: GridItemProps;
    productImageStyles?: ProductImageStyles;
    brandGridItem?: GridItemProps;
    productBrandWrapper?: InjectableCss;
    productBrandStyles?: ProductBrandStyles;
    descriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    partNumberGridItem?: GridItemProps;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    productAvailabilityStyles?: ProductAvailabilityStyles;
    priceGridItem?: GridItemProps;
    productPriceStyles?: ProductPriceStyles;
    unitOfMeasuresGridItem?: GridItemProps;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    quantityBreakPricingGridItem?: GridItemProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    quantityOrderedGridItem?: GridItemProps;
    productQuantityOrderedStyles?: TextFieldProps;
    // productStandardActionsContainer?: GridContainerProps;
    // addToCartGridItem?: GridItemProps;
    // productAddToCartButtonStyles?: ButtonPresentationProps;
    // addToListGridItem?: GridItemProps;
    // productAddToListLinkStyles?: ProductAddToListLinkStyles;
    linkWrappingImage?: ClickablePresentationProps;
    imageBadgeGridItem?: GridItemProps;
    textBadgeGridItem?: GridItemProps;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
}

export const productCarouselProductFullStyles: ProductCarouselProductFullStyles = {
    container: {
        gap: 8,
        css: css`
            width: 100%;
            height: 100%;
            padding: 4px;
            padding-top: 0px;
            background-color: white;
        `,
    },
    imageGridItem: {
        width: 12,
        css: css`
            padding: 0px;
            justify-content: center;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        height: 150px;
                    `,
                    css`
                        height: 150px;
                    `,
                    css`
                        height: 200px;
                    `,
                ]);
            }}
        `,
    },
    contentGridItem: {
        width: 12,
        css: css`
            padding-left: 20px;
            padding-right: 15px;
        `,
    },
    innerContainer: {
        gap: 8,
        css: css`
            width: 100%;
            height: 100%;
        `,
    },
    productImageStyles: {
        linkWrappingImage: {
            css: css`
                justify-content: center;
            `,
        },
    },
    brandGridItem: {
        width: 12,
        css: css`
            padding-bottom: 0px;
        `,
    },
    productBrandWrapper: {
        css: css`
            min-height: 22px;
        `,
    },
    descriptionGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
        `,
    },
    productDescriptionStyles: {
        productDetailLink: {
            typographyProps: {
                css: css`
                    font-size: 18px;
                    font-weight: 500;
                    color: ${UCSColors.gray00};
                `,
            },
        },
    },
    partNumberGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
        `,
    },
    productPartNumbersStyles: {
        container: {
            css: css`
                flex-grow: 0;
                margin-bottom: 6px;
            `,
        },
        erpNumberLabelText: {
            css: css`
                color: ${UCSColors.gray00};
                font-size: 16px;
                font-weight: 500;
                text-transform: uppercase;
                margin-right: 4px;
            `,
        },
        erpNumberValueText: {
            css: css`
                color: ${UCSColors.gray00};
                font-size: 16px;
                font-weight: 500;
                text-transform: uppercase;
            `,
        },
    },
    availabilityGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
        `,
    },
    priceGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
        `,
    },
    unitOfMeasuresGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
        `,
    },
    productUnitOfMeasureSelectStyles: {
        labelProps: {
            css: css`
                flex: 1;
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                flex: 1;
            `,
        },
    },
    quantityBreakPricingGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
        `,
    },
    quantityOrderedGridItem: {
        width: 12,
        css: css`
            padding-top: 0px;
            padding-bottom: 0px;
        `,
    },
    productQuantityOrderedStyles: {
        labelProps: {
            css: css`
                flex: 1;
            `,
        },
        labelPosition: "left",
        cssOverrides: {
            formInputWrapper: css`
                flex: 1;
            `,
        },
    },
    /* 
    productStandardActionsContainer: {
        gap: 6,
        css: css`
            padding-top: 12px;
        `,
    }, 
    addToCartGridItem: {
        width: 12,
    }, 
    productAddToCartButtonStyles: {
        css: css`
            width: 100%;
        `,
    },
    addToListGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
    productAddToListLinkStyles: {
        link: {
            typographyProps: { size: 13 },
            css: css`
                margin-bottom: 12px;
            `,
        },
    },
    */
    productBrandStyles: {
        nameLink: {
            typographyProps: {
                css: css`
                    color: ${UCSColors.gray04};
                    font-size: 16px;
                    font-weight: 500;
                    text-transform: uppercase;
                `,
            },
        },
    },

    imageBadgeGridItem: {
        width: 12,
    },
    textBadgeGridItem: {
        width: 12,
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
};

const ProductCarouselProductFull = ({
    carouselId,
    product,
    extendedStyles,
    productInfo,
    productSettings,
    updateProductInfo,
    actionsTemplate,
    history,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productCarouselProductFullStyles, extendedStyles));

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };

    if (!product || !productInfo) {
        return null;
    }

    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };

    const ImageWrapper = styled("a")<{ bgImage: string }>`
        background-position: center center;
        background-size: cover;
        width: 100%;
        position: relative;
        background-image: url("${p => p.bgImage}");
        border-bottom: 1px solid ${UCSColors.gray07};
        height: 100%;
        &:before {
            content: "";
            display: block;
            padding-top: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-top: 65%;
                    `,
                    css`
                        padding-top: 65%;
                    `,
                    css`
                        padding-top: 65%;
                    `,
                ]);
            }}
        }
    `;

    const pdpPathHandler = (productPath: string) => {
        history.push(productPath);
    };

    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: showTextBadges,
        showImageBadge: showImageBadges,
        styles,
    });

    const { imageBadges, textBadges } = useWidgetBadges({ productContext, showTextBadges, showImageBadges });

    return (
        <>
            <ProductContext.Provider value={productContext}>
                <GridContainer
                    id={`productContainer_${product.id}`}
                    {...styles.container}
                    data-test-selector="productContainer"
                >
                    <GridItem {...styles.imageGridItem}>
                        <ImageWrapper
                            onClick={() => pdpPathHandler(productContext.productInfo.productDetailPath)}
                            bgImage={productContext.product.smallImagePath || productContext.product.mediumImagePath}
                        ></ImageWrapper>
                        {showOverlayBadge && overlayBadge && (
                            <StyledWrapper
                                {...styles.badgeAreaWrapper}
                                ref={badgeAreaWrapperRef}
                                data-test-selector="productCompareBadge"
                            >
                                <ProductImage extendedStyles={styles.productImageStyles} product={productContext} />
                                <StyledWrapper {...overlayBadgeWrapperStyles} onClick={overlayBadgeWrapperClickHandler}>
                                    <Badge
                                        type={overlayBadge.badgeType}
                                        value={
                                            overlayBadge.badgeType === "Image"
                                                ? overlayBadge.largeImageBadgePath
                                                : overlayBadge.displayText
                                        }
                                        badgeTextColor={overlayBadge.textColorHexCode}
                                        badgeBackgroundColor={overlayBadge.badgeColorHexCode}
                                        badgeTextRounding={overlayBadge.badgeStyle === "Round" ? 20 : 0}
                                        imageAltText={
                                            overlayBadge.imageAltText ? overlayBadge.imageAltText : overlayBadge.name
                                        }
                                        textBadgeCss={styles.badgeText}
                                        imageBadgeProps={styles.badgeImageProps}
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        )}
                    </GridItem>
                    <GridItem {...styles.contentGridItem}>
                        <GridContainer {...styles.innerContainer}>
                            {product.brand && (
                                <GridItem {...styles.brandGridItem}>
                                    <StyledWrapper {...styles.productBrandWrapper}>
                                        <ProductBrand
                                            brand={product.brand}
                                            extendedStyles={styles.productBrandStyles}
                                        />
                                    </StyledWrapper>
                                </GridItem>
                            )}
                            <GridItem {...styles.descriptionGridItem}>
                                <ProductDescription
                                    product={productContext}
                                    extendedStyles={styles.productDescriptionStyles}
                                />
                            </GridItem>
                            <GridItem {...styles.partNumberGridItem}>
                                <ProductPartNumbers
                                    productNumber={product.productNumber}
                                    customerProductNumber={product.customerProductNumber}
                                    manufacturerItem={product.manufacturerItem}
                                    showCustomerName={true}
                                    showManufacturerItem={true}
                                    showLabel={true}
                                    extendedStyles={styles.productPartNumbersStyles}
                                />
                            </GridItem>
                            {showTextBadges && textBadges && (
                                <GridItem {...styles.textBadgeGridItem}>
                                    <ProductTextBadges
                                        badgeList={textBadges}
                                        maxBadges={maximumNumberOfTextBadges ?? 4}
                                    />{" "}
                                </GridItem>
                            )}
                            {showImageBadges && imageBadges && (
                                <GridItem {...styles.imageBadgeGridItem}>
                                    <ProductImageBadges
                                        badgeList={imageBadges}
                                        maxBadges={maximumNumberOfImageBadges ?? 4}
                                    />
                                </GridItem>
                            )}
                            <GridItem {...styles.availabilityGridItem}>
                                <ProductContextAvailability extendedStyles={styles.productAvailabilityStyles} />
                            </GridItem>
                            <GridItem {...styles.unitOfMeasuresGridItem}>
                                {product.unitOfMeasures && (
                                    <ProductUnitOfMeasureSelect
                                        labelPosition="left"
                                        extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                    />
                                )}
                            </GridItem>
                            <GridItem {...styles.quantityBreakPricingGridItem}>
                                <ProductQuantityBreakPricing
                                    extendedStyles={styles.productQuantityBreakPricingStyles}
                                />
                            </GridItem>
                            <GridItem {...styles.quantityOrderedGridItem}>
                                <ProductQuantityOrdered extendedStyles={styles.productQuantityOrderedStyles} />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
                {/*   <GridContainer {...styles.productStandardActionsContainer}>
                    <GridItem {...styles.addToCartGridItem}>
                        <ProductAddToCartButton
                            data-test-selector="addToCartBtn"
                            extendedStyles={styles.productAddToCartButtonStyles}
                        />
                    </GridItem>
                    <GridItem {...styles.addToListGridItem}>
                        <ProductAddToListLink
                            data-test-selector="addToListLink"
                            extendedStyles={styles.productAddToListLinkStyles}
                        />
                    </GridItem>
                </GridContainer>
         */}
                {actionsTemplate ? actionsTemplate(product) : []}
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(ProductCarouselProductFull));
